import * as Actions from "../Actions/Actions";
import { clone } from "../Utility";
import * as TempActions from "../Actions/TempPlaylistActions";
import _ from "lodash";

const initialState = {
  isFirstTime: true,
  playlistId: null,
  playList: {
    state: {}
  }
};
const TempState = (state = initialState, action) => {
  switch (action.type) {
    case Actions.TEMP_PLAYLIST: {
      const newState = clone(state);
      newState.playList.state.pending = false;
      newState.playList.state.loaded = true;
      newState.playList.contents = action.res;
      return newState;
    }
    case TempActions.ITEM_MOVED: {      
      const newState = clone(state);
      const { result } = action;
      if (!result.destination) return state
      console.log(newState.playList);
      let moved = _.pullAt(newState.playList.contents.video_user_categories, [
        result.source.index
      ]);
      newState.playList.contents.video_user_categories.splice(
        result.destination.index,
        0,
        moved[0]
      );
      return newState;
    }
    case TempActions.ITEM_MOVE_BEGIN: {
      const newState = clone(state);
      newState.isFirstTime = false;
      return newState;
    }
    case TempActions.RESET_IS_FIRST_MOVE: {
      const newState = clone(state);
      newState.isFirstTime = true;
      return newState;
    }
    case TempActions.REMOVE_VIDEO_FROM_PLAYLIST: {
      const newState = clone(state);
      _.remove(newState.playList.contents.video_user_categories, (o) => {
        return o.id === action.id
      })
      return newState
    }
    case TempActions.SET_ID: {
      const newState = clone(state)
      newState.playlistId = action.id
      return newState
    }
    default:
      return state;
  }
};

export default TempState;



// WEBPACK FOOTER //
// ./src/js/Reducers/tempPlaylistReducer.js